'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FieldSet.module.css';
/**
 * Compound member of <FieldSet>. Renders the <legend> element.
 * Consumers only need this in the 10% slot decomposition case.
 */
export function FieldSetLegend({ children }) {
    return _jsx("legend", { className: styles.legend, children: children });
}
//# sourceMappingURL=FieldSetLegend.js.map